<div class="app-wrapper">
    <nav class="tab_navigation">
    </nav>
    <section class="main-content ai">
        <ng-container [ngSwitch]="pageStatus">
            <div *ngSwitchCase="DONE" class="chat">
                <div class="app-main">
                    <div class="ai-introduction">
                        <span class="ai-reference">I am built with Meta <strong>Llama 3</strong></span>
                        <div class="ai-introduction-bg" [ngClass]="{'collapsed' : !displayIntro}">
                            <figure class="ai-introduction-icon"></figure>
                            <header>
                                My name is <strong>COOPER</strong> and I can help you explore Key Performance Indicators <em>(KPIs)</em>.
                            </header>
                            <span class="ai-toggle" (click)="toggleIntro()"> >> How does this work?</span>
                            <!-- <div  *ngIf="!displayIntro">
                                <span class="ia-toggle" (click)="toggleIntro()">Click to learn more</span>
                            </div> -->
                            <div class="ai-introduction-main" *ngIf="displayIntro">
                                <p>You can ask me anything related to your project dashboard. I am aware of all your
                                    projects, their status, owner and the
                                    last update that was performed. I cannot see inside your projects (yet), but I can do a
                                    great deal by simply being aware
                                    of the entire collection of projects.</p>
    
    
                                <span > >> What kind of questions can I ask?</span>

                                <p>So glad you ask. I can answer questions related to the data I can see, for instance:</p>
                                <ul>
                                    <li (click)="autoAsk($event, 'Show me 3 top stages with the most projects on and the number of projects on each.')"><a href="#">Show me 3 top stages with the most projects on and the number of projects on each.</a></li>
                                    <li (click)="autoAsk($event, 'Show me all users and the number of projects they created.')"><a href="#">Show me all users and the number of projects they created.</a></li>
                                    <li (click)="autoAsk($event, 'How many projects were started in 2024?')"><a href="#">How many projects were started in 2024?</a></li>
                                </ul>
                                <p> Go ahead....give it a go and remember, if you need help, click on the Help Me button and
                                    my human colleagues will help
                                    you.</p>

                            </div>
                        </div>
                       
                    </div>
                    <!-- chat entries content  -->
                    <div class="interaction">
                        <div class="interaction-main">
                        <ul>
                            <!-- Use *ngFor with async pipe to loop over the entries$ observable -->
                            <li *ngFor="let entry of entries$ | async" #scrollableAIChatEntry>
                              <ng-container *ngIf="entry.type === ENTRY_TYPES.answer">
                                <!-- If the entry has an 'answer' type, load the 'app-answer' component -->
                                <ai-answer 
                                    [value]="entry.value" 
                                ></ai-answer>
                              </ng-container>
                          
                              <!-- If the entry has an 'question' type, load the 'app-question' component -->
                              <ng-container *ngIf="entry.type === ENTRY_TYPES.question">
                                <ai-question 
                                    [value]="entry.value"
                                    [user]="user"
                                ></ai-question>
                              </ng-container>
                            </li>
                          </ul>
                        </div>
                    </div>
                    <!-- end chat entries content -->
                    <div class="question-prompt">
                        <span class="ai-submit" [ngClass]="{'submittable' : questionReady}" title="Back To Top"
                            (click)="onQuestionSubmit($event)"></span>
                        <form (keydown.enter)="onQuestionSubmit($event)">
                        <div class="question-ta">
                           
                            <div class="grow-prompt">
                                <div class="ai-ta" #taContainer>
                                    <textarea #textArea
                                        placeholder="> Type your question here" 
                                        [ngModel]="question" 
                                        [ngModelOptions]="{standalone: true}"
                                        (ngModelChange)="onQuestionPromptChange($event)" 
                                        (keydown)="onPromptKeyPress($event)"></textarea>
                                </div>
                            </div>
                        </div>
                        </form>
                    </div>
                </div>
            </div>
            <ng-template [ngSwitchCase]="NOT_FOUND">
                <core-helpers-box-http-error [code]="404" [message]="'Not found.'"></core-helpers-box-http-error>
            </ng-template>
            <ng-template [ngSwitchCase]="LOADING">
                <div class="dimmed dimmed_main">
                    <div class="dimmed_nav">
                        <div class="dimmed_box"></div>  
                    </div>
                
                </div>
            </ng-template>
        </ng-container>
    </section>
</div>
